module.exports = __webpack_public_path__ + "img/corpu-logo.bd40834c.png";